export default "__VITE_ASSET__DI5D_1tQ__"